import { useContext } from 'react'
import { useNavigate } from 'react-router-dom'

import { TeamAppContext } from '@/contexts/TeamContext'

import { AccessKeysPanel } from './components/AccessKeysPanel'
import { ProfileHeaderCard } from './components/ProfileHeaderCard'

export function AccessKeysPage() {
  const navigate = useNavigate()
  const teamApp = useContext(TeamAppContext)
  const isTeamContext = teamApp !== null

  return (
    <div className="flex flex-col h-full">
      <ProfileHeaderCard />
      <div className="mt-2.5 flex-1 overflow-hidden">
        <AccessKeysPanel onBack={() => navigate(isTeamContext ? '/team/profile' : '/profile')} />
      </div>
    </div>
  )
}
